import { useLocation } from "react-router-dom";
// components
import PageHeading from "../components/PageHeading";
import BasketInformation from "../components/BasketInformation";
import Button from "../components/Button";
// @interfaces
import { IBasket } from "../@interfaces/basket.interface";
import { IPurchase } from "../@interfaces/purchase.interface";
import { IMerchantConfig } from "../@interfaces/config.interface";
// styles
import styles from '../styles/pages/confirmation/PaymentConfirmationPage.module.css';
import buttonStyles from '../styles/Button.module.css';
import TransparentAndVerified from "../components/TransparentAndVerified";
import { MY_CC_URL } from "../config";

interface PaymentConfirmationPageProps {
  purchase: IPurchase | null,
  userEmail: string,
  basket: IBasket | null,
  restoreDefaultState: () => void;
  merchantCode: string;
  merchantConfig: IMerchantConfig;
}

const PaymentConfirmationPage: React.FC<PaymentConfirmationPageProps> = ({
  purchase,
  userEmail,
  basket,
  restoreDefaultState,
  merchantCode,
  merchantConfig,
}) => {
  const confirmationPage = merchantConfig?.pages?.paymentConfirmation;
  const search = new URLSearchParams(useLocation().search);
  const language = search.get("lang");

  return (
      <div className={`delayed-fadein`}>
        <PageHeading
          title={confirmationPage?.header?.title}
          text={confirmationPage?.header?.text}
        />

        <div className={styles.wrapper}>

          <div className={styles.outline}>
            <div className={styles.textCenter}>
              <div className={styles.reference}>
                <p className={styles.subtitle}>Your unique reference is</p>
                <p className={`no-translate ${styles.orderReference}`}>{purchase?.orderReference}</p>
              </div>
              <p style={{ marginTop: '0.5rem', fontSize: '0.9rem' }}>We’ve sent an email receipt to your email {userEmail}</p>

              <a className={`${buttonStyles.button} ${buttonStyles.filled}`}
                href={`${MY_CC_URL}/RM-${merchantCode}/transaction/${purchase?.purchaseId}${language ? '?lang=' + language : ''}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Trace your transaction
              </a>

              <p style={{ marginBottom: '1rem', fontSize: '0.9rem', fontWeight: 600 }}>You have reduced emissions by contributing to these projects </p>
            </div>

            <BasketInformation projects={basket?.projects} />

            <div style={{ marginTop: '1rem' }}>
              <TransparentAndVerified />
            </div>
          </div>
        </div>

        <Button
          text="Start again"
          variant="arrow"
          iconName="back"
          onClick={restoreDefaultState}
        />
      </div>
  )
};

export default PaymentConfirmationPage;
